var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { faPlus, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { ESCAPE_KEY, SUBMIT_KEY } from '../../SbGlobal/constants';
import { Icon } from '../../SbGlobal/styles';
import { NewEventContainer, NewEventInputContainer, NewEventInputIcon, NewEventText, NewEventTextInput, } from './styles';
import { sbColors as colors } from 'components/UI-helpers/colors';
export var NewEventInput = function (_a) {
    var node = _a.node, onSubmit = _a.onSubmit;
    var newEventInputRef = useRef(null);
    var _b = useState(false), isAddNewEventEntryActive = _b[0], setAddNewEventEntryActive = _b[1];
    var handleOnAddNewEvent = function () {
        setAddNewEventEntryActive(true);
    };
    var handleOnCloseNewEvent = function () {
        var _a;
        (_a = newEventInputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        setAddNewEventEntryActive(false);
    };
    var handleOnSubmitNewEvent = function (value) {
        if (value)
            onSubmit(value);
        handleOnCloseNewEvent();
    };
    var handleOnKeyDownNewEvent = function (e) {
        var _a, _b;
        if (e.key === SUBMIT_KEY) {
            handleOnSubmitNewEvent((_b = (_a = newEventInputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
        }
        if (e.key === ESCAPE_KEY) {
            handleOnCloseNewEvent();
        }
    };
    useEffect(function () {
        var _a;
        if (isAddNewEventEntryActive)
            (_a = newEventInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [isAddNewEventEntryActive]);
    return isAddNewEventEntryActive ? (_jsxs(NewEventInputContainer, { children: [_jsx(NewEventTextInput, { ref: newEventInputRef, type: "text", placeholder: "Enter event name", onKeyDown: handleOnKeyDownNewEvent }), _jsx(NewEventInputIcon, { children: _jsx(Icon, { iconSize: 14, icon: faTimes, color: colors.default, className: "cursor-pointer", onClick: handleOnCloseNewEvent }) })] })) : (_jsxs(NewEventContainer, __assign({ className: "cursor-pointer", onClick: handleOnAddNewEvent }, { children: [_jsx(Icon, { icon: faPlus, color: node.colorCode, iconSize: 12 }), _jsx(NewEventText, __assign({ color: node.colorCode }, { children: "New Event" }))] })));
};
